if (!customElements.get("thmv-coupon-progress")) {
  customElements.define(
    "thmv-coupon-progress",
    class ThmvCouponProgress extends HTMLElement {
      /**
       * data-total-amount     Cart total price in cents
       * data-min-value        Coupon minimum order value, in base currency units
       * data-code             Coupon code
       * data-locked-message   Text shown below the minimum value ([amount], [codigo])
       * data-unlocked-message Text shown once unlocked ([codigo])
       */
      constructor() {
        super();

        this.renderProgress();
      }

      get progressBar() {
        return this.querySelector(".thmv-coupon-progress-bar");
      }

      get messageWrapper() {
        return this.querySelector(".thmv-coupon-progress-message");
      }

      get copyWrapper() {
        return this.closest("custom-copy-text");
      }

      renderProgress() {
        const cartTotalAmount = this.dataset.totalAmount;
        const minValue = this.dataset.minValue;
        const code = this.dataset.code || "";

        if (!webvista.isNumeric(cartTotalAmount) || !webvista.isNumeric(minValue))
          return;

        const minValueLocal =
          Math.round(parseInt(minValue) * (Shopify.currency.rate || 1)) * 100; // cents

        const isUnlocked = cartTotalAmount - minValueLocal >= 0;
        let progress;

        if (isUnlocked) {
          progress = 100;
          if (this.messageWrapper)
            this.messageWrapper.innerHTML = (
              this.dataset.unlockedMessage || ""
            ).replace("[codigo]", code);
        } else {
          progress = (cartTotalAmount * 100) / minValueLocal;

          const amountToQualify = minValueLocal - cartTotalAmount;
          const amountFormatted = webvista.formatPriceAmount(
            amountToQualify,
            Shopify.currency.active,
          );
          if (this.messageWrapper)
            this.messageWrapper.innerHTML = (this.dataset.lockedMessage || "")
              .replace("[amount]", `<span>${amountFormatted}</span>`)
              .replace("[codigo]", code);
        }

        this.classList.toggle("thmv-has-unlocked", isUnlocked);

        if (this.progressBar)
          this.progressBar.style.setProperty(
            "--thmv-coupon-progress",
            `${progress}%`,
          );

        // A cópia só fica disponível quando o cupom está liberado.
        if (this.copyWrapper) {
          this.copyWrapper.classList.toggle("thmv-has-unlocked-copy", isUnlocked);
          this.copyWrapper.setAttribute("tabindex", isUnlocked ? "0" : "-1");
          this.copyWrapper.setAttribute("aria-disabled", String(!isUnlocked));
        }
      }
    },
  );
}
